interface Props {
  props: {
    columns?: string[];
    rows?: unknown[][];
    caption?: string;
  };
}

function renderCell(value: unknown): React.ReactNode {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return JSON.stringify(value);
}

export function PanelDataTable({ props }: Props) {
  const columns = props?.columns ?? [];
  const rows = props?.rows ?? [];
  return (
    <div style={{ margin: '4px 0' }}>
      {props?.caption && (
        <div
          style={{
            fontSize: 11,
            color: 'var(--text-soft)',
            marginBottom: 6,
            textTransform: 'uppercase',
            letterSpacing: 0.3,
            fontWeight: 600,
          }}
        >
          {props.caption}
        </div>
      )}
      <div
        style={{
          border: '1px solid var(--border)',
          borderRadius: 6,
          overflowX: 'auto',
          background: 'var(--surface)',
        }}
      >
        <table
          style={{
            borderCollapse: 'collapse',
            width: '100%',
            fontSize: 12,
            color: 'var(--text)',
          }}
        >
          <thead>
            <tr>
              {columns.map((c) => (
                <th
                  key={c}
                  style={{
                    textAlign: 'left',
                    padding: '6px 10px',
                    borderBottom: '1px solid var(--border-strong)',
                    fontWeight: 600,
                    background: 'var(--bg-alt)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {columns.map((c, j) => (
                  <td
                    key={c}
                    style={{
                      padding: '6px 10px',
                      borderBottom: i === rows.length - 1 ? 0 : '1px solid var(--border)',
                      background: i % 2 === 0 ? 'transparent' : 'var(--bg-alt)',
                      verticalAlign: 'top',
                    }}
                  >
                    {renderCell(row[j])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
